const stats = [
  { value: '7년+', label: '전문 운영 기간' },
  { value: '24H', label: '365일 상담 가능' },
  { value: '전카드', label: '카드대출 서비스' },
  { value: '100%', label: '비대면 처리' },
];

export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-24 bg-[#f7f9fa]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <span className="inline-block bg-[#03C75A]/10 text-[#03C75A] text-xs sm:text-sm font-bold px-3 sm:px-4 py-1.5 rounded-full mb-3 sm:mb-4">
            회사소개
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-3 sm:mb-4">주식회사 머니박스대부중개</h2>
          <p className="text-gray-500 text-sm sm:text-lg max-w-2xl mx-auto leading-relaxed">
            7년동안 한자리에서 계속운영중인 신뢰할 수 있는 자격을 갖춘 신용카드 전문 대출 회사입니다
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-center mb-8 md:mb-16">
          {/* Left Image */}
          <div className="relative rounded-2xl overflow-hidden h-52 sm:h-72 md:h-96">
            <img
              src="https://public.readdy.ai/ai/img_res/0290009b611677d42fbfdca50085ff12.jpg"
              alt="머니박스대부중개 사무실"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute top-4 left-4 bg-[#03C75A] text-white text-xs sm:text-sm font-bold px-3 sm:px-4 py-1.5 sm:py-2 rounded-full">
              7년 경력
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
          </div>

          {/* Right Content */}
          <div>
            <h3 className="text-xl sm:text-2xl font-black text-gray-900 mb-3 sm:mb-4">
              신용카드 대출 전문, <span className="text-[#03C75A]">7년의 신뢰</span>
            </h3>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-4 sm:mb-6">
              주식회사 머니박스대부중개는 마포구에서 신용카드 관련 대출 중개 업무를 7년간계속 운영중인 전문 회사입니다. 신용카드한도대출, 신용카드소지자 대출, 법인카드 대출 등 다양한 서비스로 고객의 안심을 해소시켜 드립니다.
            </p>
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed mb-6 sm:mb-8">
              비대면으로 신속하게 처리해 드립니다. 24시간 365일 신호가 빠른 도움을 제공합니다.
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 sm:gap-3">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center bg-white rounded-xl p-2.5 sm:p-3 border border-gray-100">
                  <div className="text-lg sm:text-xl font-black text-[#03C75A] mb-0.5">{stat.value}</div>
                  <div className="text-xs text-gray-500 leading-tight">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Info Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          {/* Business Info */}
          <div className="bg-white rounded-2xl p-5 sm:p-6 border border-gray-100">
            <div className="w-10 h-10 flex items-center justify-center bg-[#03C75A]/10 rounded-xl mb-3 sm:mb-4">
              <i className="ri-government-line text-xl text-[#03C75A]"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 text-sm sm:text-base">사업자 정보</h4>
            <div className="space-y-2 text-xs sm:text-sm text-gray-600">
              <div className="flex justify-between gap-2">
                <span className="text-gray-400 shrink-0">회사명</span>
                <span className="font-medium text-right">주식회사 머니박스대부중개</span>
              </div>
              <div className="flex justify-between gap-2">
                <span className="text-gray-400 shrink-0">사업자번호</span>
                <span className="font-medium">381-86-01843</span>
              </div>
              <div className="flex justify-between gap-2">
                <span className="text-gray-400 shrink-0">업종</span>
                <span className="font-medium">대부중개업</span>
              </div>
            </div>
          </div>

          {/* Location */}
          <div className="bg-white rounded-2xl p-5 sm:p-6 border border-gray-100">
            <div className="w-10 h-10 flex items-center justify-center bg-[#03C75A]/10 rounded-xl mb-3 sm:mb-4">
              <i className="ri-map-pin-2-line text-xl text-[#03C75A]"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 text-sm sm:text-base">위치 안내</h4>
            <p className="text-xs sm:text-sm text-gray-600 mb-3 leading-relaxed">
              서울특별시 마포구<br />신촌로 162, 706호
            </p>
            <a
              href="https://map.naver.com/v5/search/서울시+마포구+신촌로+162"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1 text-xs sm:text-sm font-semibold text-[#03C75A] hover:underline cursor-pointer"
            >
              <i className="ri-map-2-line"></i>
              지도에서 보기
            </a>
          </div>

          {/* Contact */}
          <div className="bg-white rounded-2xl p-5 sm:p-6 border border-gray-100">
            <div className="w-10 h-10 flex items-center justify-center bg-[#03C75A]/10 rounded-xl mb-3 sm:mb-4">
              <i className="ri-phone-line text-xl text-[#03C75A]"></i>
            </div>
            <h4 className="font-bold text-gray-900 mb-2 sm:mb-3 text-sm sm:text-base">연락처</h4>
            <div className="space-y-2">
              <a
                href="tel:01066065909"
                className="flex items-center gap-2 text-[#03C75A] font-bold text-base sm:text-lg hover:underline cursor-pointer"
              >
                <i className="ri-smartphone-line text-base"></i>
                010-6606-5909
              </a>
              <a
                href="tel:027045909"
                className="flex items-center gap-2 text-gray-700 font-semibold text-xs sm:text-sm hover:underline cursor-pointer"
              >
                <i className="ri-phone-line text-base"></i>
                02-704-5909
              </a>
              <p className="text-xs text-[#03C75A] font-medium mt-2">
                <i className="ri-time-line mr-1"></i>
                24시간 365일 운영
              </p>
            </div>
          </div>
        </div>

        {/* Map */}
        <div className="mt-6 sm:mt-10 rounded-2xl overflow-hidden border border-gray-100 h-48 sm:h-64">
          <iframe
            title="머니박스대부중개 위치"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3163.0!2d126.9344!3d37.5565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c99b18e4c8a3b%3A0x0!2z7ISc7Jq47Yq567OE7IucIOub7IqkIOyImOy8gOroIDE2Mg!5e0!3m2!1sko!2skr!4v1609940400000!5m2!1sko!2skr"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </div>
    </section>
  );
}
